import uniqBy from 'lodash.uniqby';

import ITableCol from '@/interfaces/ITableCol';

function getTableColumns(
    source: { [key: string]: any },
    sortable: boolean = false,
    hideColumns?: string[],
    handlerEvent?: { name: string, index?: number }
): ITableCol[] | undefined {
    if (source) {
        if (source.length > 0) {
            const items = Object.keys(source[0]).map(item => {
                return {
                    key: item,
                    sortable
                }
            });

            if (hideColumns) {
                hideColumns.forEach((col: string) => {
                    const findHideColumn = items.findIndex(i => i.key.toLowerCase() === col.toLowerCase());
                    if (findHideColumn !== -1) {
                        items.splice(findHideColumn, 1)
                    }
                });

            }

            const fieldId = items.findIndex(i => i.key.toLowerCase() === 'id');

            if (fieldId !== -1) {
                items.splice(0, 0, items[fieldId])
            }

            if (handlerEvent) {
                if (handlerEvent.index) {
                    items.splice(handlerEvent.index, 0, {
                        key: handlerEvent.name,
                        sortable: false
                    });
                } else {
                    items.push({
                        key: handlerEvent.name,
                        sortable: false
                    });
                }
            }
            return uniqBy(items, 'key');
        }
    }
}

export default getTableColumns;
